'use strict';

const BaseModel = require('./base');

class QuantityModel extends BaseModel {
  constructor(partySizeString, options) {
    const attributes = { partySize: parseInt(partySizeString, 10) };
    super(attributes, options);
  }

  getPartySize() {
    return this.get('partySize');
  }
}

module.exports = QuantityModel;
